import { render, staticRenderFns } from "./JoinTheClub.vue?vue&type=template&id=f74e87b0"
import script from "./JoinTheClub.vue?vue&type=script&lang=js"
export * from "./JoinTheClub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports